"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_OPTIONAL_ACCOUNT_MAPPING_SLOTS = exports.ACCOUNTING_REQUIRED_ACCOUNT_MAPPING_SLOTS = exports.AccountingAccountMappingSlot = exports.ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT = exports.ACCOUNTING_PROVIDER_DISPLAY_NAMES = exports.AccountingSyncIdempotencyStatus = exports.BusinessAccountingConnectionStatus = exports.AccountingProviderStatus = void 0;
exports.isAccountingSyncRetriableFailure = isAccountingSyncRetriableFailure;
exports.isAccountingSyncTerminalFailure = isAccountingSyncTerminalFailure;
var AccountingProviderStatus;
(function (AccountingProviderStatus) {
    AccountingProviderStatus["ACTIVE"] = "ACTIVE";
    AccountingProviderStatus["DISABLED"] = "DISABLED";
    AccountingProviderStatus["DEPRECATED"] = "DEPRECATED";
})(AccountingProviderStatus || (exports.AccountingProviderStatus = AccountingProviderStatus = {}));
var BusinessAccountingConnectionStatus;
(function (BusinessAccountingConnectionStatus) {
    BusinessAccountingConnectionStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    BusinessAccountingConnectionStatus["CONNECTING"] = "CONNECTING";
    BusinessAccountingConnectionStatus["CONNECTED"] = "CONNECTED";
    BusinessAccountingConnectionStatus["FAILED"] = "FAILED";
})(BusinessAccountingConnectionStatus || (exports.BusinessAccountingConnectionStatus = BusinessAccountingConnectionStatus = {}));
var AccountingSyncIdempotencyStatus;
(function (AccountingSyncIdempotencyStatus) {
    AccountingSyncIdempotencyStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AccountingSyncIdempotencyStatus["SUCCEEDED"] = "SUCCEEDED";
    AccountingSyncIdempotencyStatus["FAILED"] = "FAILED";
    /** Retry budget exhausted; row is not picked up by the failed-sync worker. Filter on this instead of FAILED. */
    AccountingSyncIdempotencyStatus["RETRY_EXHAUSTED"] = "RETRY_EXHAUSTED";
})(AccountingSyncIdempotencyStatus || (exports.AccountingSyncIdempotencyStatus = AccountingSyncIdempotencyStatus = {}));
/** Rows the failed-sync worker may still pick up (`retry_count` cap applies separately). */
function isAccountingSyncRetriableFailure(status) {
    return status === AccountingSyncIdempotencyStatus.FAILED;
}
/** FAILED or RETRY_EXHAUSTED — use for UI error state and ops dashboards. */
function isAccountingSyncTerminalFailure(status) {
    return (status === AccountingSyncIdempotencyStatus.FAILED ||
        status === AccountingSyncIdempotencyStatus.RETRY_EXHAUSTED);
}
exports.ACCOUNTING_PROVIDER_DISPLAY_NAMES = {
    xero: "Xero",
    quickbooks: "QuickBooks",
};
/** Fixed handshake ref for org-wide default account slots (unique with mappingType). */
exports.ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT = "default";
/**
 * Account slots Handshake needs before invoice / sync flows.
 * Stored as `mapping_type` with `handshake_ref` = {@link ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT}.
 */
var AccountingAccountMappingSlot;
(function (AccountingAccountMappingSlot) {
    AccountingAccountMappingSlot["DEFAULT_REVENUE"] = "DEFAULT_REVENUE";
    /** Line item account for Handshake platform fee on the sales invoice (business + client fee portions). */
    AccountingAccountMappingSlot["HANDSHAKE_PLATFORM_FEE"] = "HANDSHAKE_PLATFORM_FEE";
    /** Clearing / Handshake wallet bank — escrow payments are allocated here; withdrawals transfer out of this account. */
    AccountingAccountMappingSlot["ACCOUNTS_RECEIVABLE"] = "ACCOUNTS_RECEIVABLE";
    /** Operating bank that receives withdrawal payouts (transfer **to** this account). */
    AccountingAccountMappingSlot["WITHDRAWAL_DESTINATION_BANK"] = "WITHDRAWAL_DESTINATION_BANK";
    /** @deprecated Renamed to {@link AccountingAccountMappingSlot.WITHDRAWAL_DESTINATION_BANK}. DB rows may still use this value. */
    AccountingAccountMappingSlot["WITHDRAWAL_SOURCE_BANK"] = "WITHDRAWAL_SOURCE_BANK";
    /** @deprecated No longer used (withdrawals are bank transfers, not spend-money + expense). */
    AccountingAccountMappingSlot["WITHDRAWAL_EXPENSE"] = "WITHDRAWAL_EXPENSE";
})(AccountingAccountMappingSlot || (exports.AccountingAccountMappingSlot = AccountingAccountMappingSlot = {}));
exports.ACCOUNTING_REQUIRED_ACCOUNT_MAPPING_SLOTS = [
    AccountingAccountMappingSlot.DEFAULT_REVENUE,
    AccountingAccountMappingSlot.HANDSHAKE_PLATFORM_FEE,
    AccountingAccountMappingSlot.ACCOUNTS_RECEIVABLE,
];
/** Destination operating bank for withdrawal bank transfers; omitting skips withdrawal sync only. */
exports.ACCOUNTING_OPTIONAL_ACCOUNT_MAPPING_SLOTS = [
    AccountingAccountMappingSlot.WITHDRAWAL_DESTINATION_BANK,
];
